export const notifications = {
  TOS: "TOS",
  Cookies: "Cookies",
};

export type BaseNotification = {
  message: string;
  notificationType: NotificationTypes;
  content?: string;
};

export enum NotificationTypes {
  Success,
  Failure,
}
